import { Route, Routes, UrlSegment, UrlSegmentGroup, UrlMatchResult } from '@angular/router';

import { ElectionConnectionErrorComponent } from './election-connection-error/election-connection-error.component';
import { ElectionGenericErrorComponent } from './election-generic-error/election-generic-error.component';
import { ElectionNotFoundComponent } from './election-not-found/election-not-found.component';
import { ParticipantLoginComponent } from './login/participant-login.component';

const alphaNumericPattern = /^[a-zA-Z0-9]+$/;
const guidPattern = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

export function participantElectionMatcher(
  segments: UrlSegment[],
  _group: UrlSegmentGroup,
  _route: Route,
): UrlMatchResult | null {
  if (segments.length !== 2) {
    return null;
  }

  const [companyPrefix, electionId] = segments;

  if (!alphaNumericPattern.test(companyPrefix.path) || !guidPattern.test(electionId.path)) {
    return null;
  }

  return {
    consumed: segments,
    posParams: {
      companyPrefix,
      electionId,
    },
  };
}

export const routes: Routes = [
  {
    path: 'erro-comunicacao',
    component: ElectionConnectionErrorComponent,
  },
  {
    path: 'erro-generico',
    component: ElectionGenericErrorComponent,
  },
  {
    path: 'eleicao-nao-encontrada',
    component: ElectionNotFoundComponent,
  },
  {
    matcher: participantElectionMatcher,
    component: ParticipantLoginComponent,
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'eleicao-nao-encontrada',
  },
  {
    path: '**',
    redirectTo: 'eleicao-nao-encontrada',
  },
];